<template>
  <div>
    <div class="not-found-page absolute text-center full-width">
      <div class="text absolute full-width full-height flex justify-center items-center ops">
        404
      </div>
      <div class="text text-25-400 absolute full-width full-height column justify-center items-center">
        <div v-html="$t('text.pageNotFound')"/>

        <AppButton
          class="q-mt-lg"
          icon-right="fl:home-1"
          text-color="black"
          :to="{ name: account ? ENUMS.ROUTES.DASHBOARD.INDEX : ENUMS.ROUTES.AUTH.SIGNIN }"
          :label="$t('button.goHome')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from 'common/components/buttons/AppButton';
import { mapState } from 'vuex';

export default {
  name: 'Error404',
  components: { AppButton },
  computed: {
    ...mapState('app', ['account']),
  },
};
</script>

<style scoped lang="scss">
.not-found-page {
  height: calc(100% - 115px);

  .ops {
    font-size: 470px;
    font-weight: 700;
    color: $grey-6;
    line-height: 0;
  }

  .text {
    top: 0;
  }
}
</style>
